var render = function render(){
  var _this = this,
    _vm$sellerDetails,
    _vm$sellerDetails$pid,
    _vm$sellerDetails$pid2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "border-bottom primary-header desktop-view-header"
  }, [_c('b-container', {
    attrs: {
      "id": "element"
    }
  }, [_c('b-row', {
    staticStyle: {
      "flex-wrap": "nowrap"
    }
  }, [_c('b-col', {
    staticClass: "d-flex justify-content-start align-items-center",
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm.modules.home ? _c('a', {
    attrs: {
      "href": "/"
    },
    on: {
      "click": function () {
        return _vm.updateWebsiteMode('product');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/logo.png"
    }
  })]) : _vm._e()])]), _c('b-col', [_c('div', {
    staticClass: "search-mobile-view mt-2"
  }, [_vm.$options.components['search-bar'] ? [_c('search-bar')] : _vm._e()], 2)]), _vm.showNavItems ? _c('b-col', {
    staticClass: "d-flex justify-content-start align-items-center"
  }, [_c('h5', {
    staticClass: "font-16 ml-3 mt-2 cursor-pointer font-weight-bold text-black",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("home")) + " ")]), _c('h5', {
    staticClass: "font-16 ml-3 mt-2 cursor-pointer font-weight-bold text-black",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/about');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("about")) + " ")]), _c('h5', {
    staticClass: "font-16 ml-3 mr-4 mt-2 cursor-pointer font-weight-bold text-black",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/contact');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("contact")) + " ")])]) : _vm._e(), _c('b-col', {
    staticClass: "d-flex justify-content-end align-items-center",
    attrs: {
      "md": "2"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled heartbagUl mb-0",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm.showChatIcon ? _c('li', {
    staticClass: "ml-2"
  }, [_c('b-dropdown', {
    staticClass: "chat-dropdown",
    attrs: {
      "right": "",
      "no-caret": "",
      "variant": "link",
      "toggle-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('div', {
          staticClass: "icon-wrapper"
        }, [_c('b-iconstack', [_c('b-icon', {
          attrs: {
            "icon": "chat-left-text",
            "variant": "black"
          }
        })], 1)], 1)];
      },
      proxy: true
    }], null, false, 1590376037)
  }, _vm._l(_vm.chatSellerList, function (seller, index) {
    return _c('div', {
      key: index,
      staticClass: "primary-header"
    }, [_c('b-dropdown-item', {
      staticClass: "drop-list",
      on: {
        "click": function () {
          return _vm.openChatPopup(seller);
        }
      }
    }, [_c('b-icon', {
      staticClass: "mr-2",
      attrs: {
        "icon": "person-circle"
      }
    }), _vm._v(" " + _vm._s(seller.sellerName) + " ")], 1)], 1);
  }), 0)], 1) : _vm._e(), _vm.showWishlistIcon ? _c('li', {
    staticClass: "ml-2"
  }, [_c('div', {
    staticClass: "wishlist-header"
  }, [_c('router-link', {
    staticClass: "wishlist-link",
    attrs: {
      "to": {
        path: '/wishlist'
      }
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('b-iconstack', [_c('b-icon', {
    attrs: {
      "icon": "heart",
      "variant": "black"
    }
  })], 1), _vm.listData.length > 0 ? _c('h6', {
    staticClass: "wishlist-notification"
  }, [_vm._v(" " + _vm._s(_vm.wishlistItemCount) + " ")]) : _vm._e()], 1)])], 1)]) : _vm._e(), _vm.showCartIcon ? _c('li', [_c('div', {
    staticClass: "header-cart"
  }, [_c('b-iconstack', {
    staticClass: "pointer",
    on: {
      "click": _vm.toggleCart
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "bag",
      "variant": "black"
    }
  })], 1), _c('SliderCart', {
    attrs: {
      "isVisible": _vm.isCartVisible
    },
    on: {
      "toggle-cart": _vm.toggleCart
    }
  }), _vm.cartData.length > 0 ? _c('h6', {
    staticClass: "checkout-notification"
  }, [_vm._v(" " + _vm._s(_vm.cartItemCount) + " ")]) : _vm._e()], 1)]) : _vm._e(), _c('li', [_c('div', [!_vm.$store.state['auth'].isLoggedin ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function () {
        return _this.$router.push({
          name: 'login with'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login")))]) : _c('div', {
    staticClass: "header-loginsec user-name d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2 text-dark font-16 font-weight-bold"
  }, [!_vm.$store.state['auth'].isLoggedin ? [_vm._v(" " + _vm._s(_vm.$t("hello")) + " ")] : [_vm._v(" " + _vm._s(_vm.userInfo.name.first && _vm.userInfo.name.first.length > 6 ? _vm.userInfo.name.first.substring(0, 6) + "..." : _vm.userInfo.name.first) + " ")]], 2), _c('b-dropdown', {
    staticClass: "profile-dropdown",
    class: Object.keys(_vm.themeColor).length !== 0 ? 'dropdown-toggle-new' : '',
    attrs: {
      "id": "dropdown-1"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('b-iconstack', [_c('b-icon', {
          attrs: {
            "icon": "person",
            "variant": "black"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    staticClass: "d-flex align-items-center",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/profile');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/profile.png"
    }
  }), _c('span', {
    staticClass: "text-dark ml-2"
  }, [_vm._v(_vm._s(_vm.$t("profile")))])]), _c('b-dropdown-item', {
    staticClass: "d-flex align-items-center",
    on: {
      "click": _vm.myOrder
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/order.png"
    }
  }), _c('span', {
    staticClass: "text-dark ml-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("myorders")))])]), !_vm.showWishlistIcon ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        return _vm.$router.push('/wishlist');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/wishlist.png"
    }
  }), _c('span', {
    staticClass: "text-dark ml-2"
  }, [_vm._v(_vm._s(_vm.$t("mywishlist")))])]) : _vm._e(), !_vm.showCartIcon ? _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        return _vm.$router.push('/checkout');
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "19px"
    },
    attrs: {
      "src": "img/navbar/Bag.png"
    }
  }), _c('span', {
    staticClass: "text-dark ml-2"
  }, [_vm._v(_vm._s(_vm.$t("mycart")) + " ")])]) : _vm._e(), _c('b-dropdown-item', {
    staticClass: "d-flex align-items-center",
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/logout.png"
    }
  }), _c('span', {
    staticClass: "text-dark ml-2"
  }, [_vm._v(_vm._s(_vm.$t("logout")))])])], 1)], 1)], 1)])])])], 1)], 1)], 1), _c('div', {
    staticClass: "primary-header mobile-view-header"
  }, [_c('b-container', {
    attrs: {
      "fluid": "",
      "id": "element"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [!_vm.showMobileMenu ? _c('b-icon', {
    staticClass: "ml-1 direct-class",
    attrs: {
      "icon": "list",
      "scale": "2",
      "variant": "dark"
    },
    on: {
      "click": _vm.viewMobileMenu
    }
  }) : _vm._e(), _vm.showMobileMenu ? _c('b-icon', {
    staticClass: "ml-1 direct-class",
    attrs: {
      "icon": "x",
      "scale": "2.7",
      "variant": "dark"
    },
    on: {
      "click": _vm.hideMobileMenu
    }
  }) : _vm._e(), _c('div', {
    staticClass: "logo"
  }, [_vm.modules.home ? _c('a', {
    attrs: {
      "href": "/"
    },
    on: {
      "click": function () {
        return _vm.updateWebsiteMode('product');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/logo.png"
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm.showCartIcon ? _c('div', {
    staticClass: "header-cart"
  }, [_c('button', {
    on: {
      "click": _vm.toggleCart
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/Bag.png",
      "alt": ""
    }
  })]), _c('SliderCart', {
    attrs: {
      "isVisible": _vm.isCartVisible
    },
    on: {
      "toggle-cart": _vm.toggleCart
    }
  }), _vm.cartData.length > 0 ? _c('h6', {
    staticClass: "checkout-notification"
  }, [_vm._v(" " + _vm._s(_vm.cartItemCount) + " ")]) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "forMobileProfile"
  }, [!_vm.$store.state['auth'].isLoggedin ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function () {
        return _this.$router.push({
          name: 'login'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login")))]) : _c('div', {
    staticClass: "header-loginsec user-name d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2 text-dark font-16 font-weight-bold"
  }, [!_vm.$store.state['auth'].isLoggedin ? [_vm._v(" " + _vm._s(_vm.$t("hello")) + " ")] : [_vm._v(" " + _vm._s(_vm.userInfo.name.first && _vm.userInfo.name.first.length > 6 ? _vm.userInfo.name.first.substring(0, 6) + "..." : _vm.userInfo.name.first) + " ")]], 2), _c('b-dropdown', {
    class: Object.keys(_vm.themeColor).length !== 0 ? 'dropdown-toggle-new' : '',
    attrs: {
      "id": "dropdown-1"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('b-iconstack', [_c('b-icon', {
          attrs: {
            "icon": "person",
            "variant": "black"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    staticClass: "d-flex align-items-center",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/profile');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/profile.png"
    }
  }), _c('span', {
    staticClass: "text-dark ml-2"
  }, [_vm._v(_vm._s(_vm.$t("profile")))])]), _c('b-dropdown-item', {
    staticClass: "d-flex align-items-center",
    on: {
      "click": _vm.myOrder
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/order.png"
    }
  }), _c('span', {
    staticClass: "text-dark ml-2"
  }, [_vm._v(_vm._s(_vm.$t("myorders")))])]), _c('b-dropdown-item', {
    staticClass: "d-flex align-items-center",
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    attrs: {
      "src": "img/navbar/logout.png"
    }
  }), _c('span', {
    staticClass: "text-dark ml-2"
  }, [_vm._v(_vm._s(_vm.$t("logout")))])])], 1)], 1)], 1)])], 1), [_c('transition', {
    attrs: {
      "name": "fade-slide"
    }
  }, [_vm.showMobileMenu ? _c('div', {
    staticClass: "menu-mobile-view"
  }, [_c('h5', {
    staticClass: "font-16 mb-3 cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.showMobileMenu = false;
        _vm.$router.push('/');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("home")) + " ")]), _c('h5', {
    staticClass: "font-16 mb-3 cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.showMobileMenu = false;
        _vm.$router.push('/about');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("about")) + " ")]), _vm.isLoggedin ? _c('h5', {
    staticClass: "font-16 mb-3 cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.showMobileMenu = false;
        _vm.$router.push('/profile');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("footer.myAccount")) + " ")]) : _vm._e(), _c('h5', {
    staticClass: "font-16 mb-3 cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.showMobileMenu = false;
        _vm.$router.push('/contact');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("contact")) + " ")]), !_vm.$store.state['auth'].isLoggedin ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showMobileMenu = false;
        this.$router.push({
          name: 'login'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login")))]) : _vm._e()], 1) : _vm._e()])]], 2)], 1), _c('b-modal', {
    attrs: {
      "id": "bv-modal-chat-option",
      "size": "lg",
      "title": ((_vm$sellerDetails = _vm.sellerDetails) === null || _vm$sellerDetails === void 0 ? void 0 : (_vm$sellerDetails$pid = _vm$sellerDetails.pid) === null || _vm$sellerDetails$pid === void 0 ? void 0 : (_vm$sellerDetails$pid2 = _vm$sellerDetails$pid.authentication) === null || _vm$sellerDetails$pid2 === void 0 ? void 0 : _vm$sellerDetails$pid2.userName) || 'Seller Chat',
      "hide-footer": true,
      "hide-header": false,
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "centered": "",
      "header-class": "my-class",
      "body-class": "p-0"
    }
  }, [_c('ChatBox', {
    attrs: {
      "sellerDetails": _vm.sellerDetails
    }
  })], 1)], 1)], 1), _c('b-container', {
    staticClass: "p-0 mobile-hide-margin slot-container",
    attrs: {
      "fluid": ""
    }
  }, [_vm._t("default")], 2), _c('chatbot-chatbot'), _c('div', {
    staticClass: "footer-bg"
  }, [_c('b-container', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "footer_content"
  }, [_c('h5', {
    staticClass: "font-16 mb-3 cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("home")) + " ")]), _c('h5', {
    staticClass: "font-16 mb-3 cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/about');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("about")) + " ")]), _vm.isLoggedin ? _c('h5', {
    staticClass: "font-16 mb-3 cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/profile');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("footer.myAccount")) + " ")]) : _vm._e(), _c('h5', {
    staticClass: "font-16 mb-3 cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/contact');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("contact")) + " ")])]), _c('hr', {
    staticClass: "mt-2 hr-1"
  }), _c('div', {
    staticClass: "copyrightSec d-flex justify-content-center align-items-center pb-2"
  }, [_c('p', {
    staticClass: "mb-0 font-14 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.appName) + " © " + _vm._s(new Date().getFullYear()) + " " + _vm._s(_vm.$t("footer.copyright")) + ". Powered by "), _c('a', {
    attrs: {
      "href": "https://fastforge.ai/",
      "target": "_blank"
    }
  }, [_vm._v("FastForge")])])])])], 1)], 1)], 1), _c('b-container', {
    staticClass: "mobileMenuSec"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "teka-mobile-menu"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "house-door"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("home")) + " ")], 1), _c('router-link', {
    attrs: {
      "to": "/my-order"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "cart4"
    }
  }), _c('span', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t("myorders")))])], 1), _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "person-circle"
    }
  }), _vm._v(_vm._s(_vm.$t("footer.myAccount")) + " ")], 1)], 1)])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }